import React, { useEffect, useState } from "react";
import { FlexContainer, H1Text, Img, UpiPanel2, PH3Text, Spinner, LeftBackButtonText } from "../../design";
import {  API } from "../../api";
import BaseSplitPage from "../../components/splitpage";
import Header from "./smallscreen/header";
import Support from "../../components/support";
import SwirepayWhiteLogo from "../../assets/imgs/Swirepay-white.svg";
import QRCode from "qrcode.react";
import PaymentError from "../../components/paymenterror";
import { CloudDownloadOutlined } from "@ant-design/icons";
import { PAGES } from "../../appconstants";

type Props = {
    history: {
        push: Function,
    },
}

const RtpPaymentLink = (props: Props) => {
    const [errorMessage, setErrorMessage] = useState();
    const [entity, setEntity] = useState(null);
    const [isShowSpinner, setShowSpinner] = useState(false);

    const { location: { search, pathname } } = props;
    const params = new URLSearchParams(search);
    const currentWalletGid = params.get('gid');

    useEffect(() => {
       getPkPassDetails();
    }, []);

    const getPkPassDetails = async () => {
        const { data: { entity } } = await API.get(`/rewards/wallet-bank/${currentWalletGid}/pk-pass`,
        {
            headers: {
                'RewardsAuthorization': `Bearer ${localStorage.getItem('rtpAccessToken')}`
            },
        });
        if(entity){
            setEntity(entity);
        } 
    };

    const download = async () => {
        if (entity && entity.applePkPassDownloadUrl) {
        setShowSpinner(true);
            try {
                window.open(entity.applePkPassDownloadUrl);
            } catch (e) {
                setShowSpinner(false);
                setErrorMessage(e && e.response ? e.response?.data?.message : 'Unable to process request. Please try again later');
            } finally {
                setShowSpinner(false);
            }
        }
    };

    return (
        <BaseSplitPage left={
            <>
                <FlexContainer
                    flexDirection="column"
                    position="relative"
                    display="block"
                    height="100%"
                >
                    <div>
                        <LeftBackButtonText
                            onClick={() => { props.history.push(PAGES.RTP_ADDED_BANKS); }}
                        >
                            Back
                        </LeftBackButtonText>
                        <H1Text>
                            WALLET DOWNLOAD
                        </H1Text>
                    </div>
                    <div style={{ position: "sticky", top: "85%" }}>
                        <Support email={null}
                            phone={null} />
                    </div>
                </FlexContainer>
            </>
        } right={
            <>
                <Header payment={null} />
                <FlexContainer
                    className="pt-3 pt-lg-5 w-100 p-2"
                    box-shadow="0 0 15px 0 rgba(0, 0, 0, 0.1)"
                    display="flow-root"
                    backgroundColor="#fff"
                    borderRadius="10px"
                >
                    <div className="px-1 px-md-4 mt-2">
                        <FlexContainer
                            flexDirection="column"
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                alignContent: "center",
                            }}
                        >
                            <div 
                            style={{
                                width: 320,
                                border: "1px solid #e0e0e0",
                                borderRadius: 16,
                                padding: 16,
                                backgroundColor: "#1474E5",
                                boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                                fontFamily: "Arial, sans-serif",
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                alignContent: "center",
                                color: "#fff",
                            }}>
                            <H1Text text-align="center" className="mt-4" color="#fff">
                                SpREE CARD
                            </H1Text>
                            <UpiPanel2 style={{ border: "none" }}>
                                <PH3Text
                                marginTop='20px'
                                marginBottom='20px'
                                fontSize='17px'
                                marginLeft='0px'
                                color='#fff'
                                >
                                 {entity?.walletId}
                                </PH3Text>
                                <Img style={{ heigth: "70px", width: "200px" }}
                                    src={SwirepayWhiteLogo}
                                />
                                <div
                                style={{
                                    marginTop: '20px',
                                    padding: '10px',
                                    background: 'white',
                                    borderRadius: '7px',
                                }}
                                >
                                <QRCode
                                    id="qrCodeEl"
                                    size={160}
                                    value={entity?.qrCodeEncoded || ''}
                                />
                                </div>
                            </UpiPanel2>
                            </div>
                            <button 
                              style={{ padding: '15px', background: 'black', color: 'white', borderRadius: '10px', marginTop: '0.5rem', marginBotton: '0.5rem' }}
                              onClick={download}
                            >
                                <CloudDownloadOutlined style={{ fontSize: '20px' }} /> Download Wallet
                            </button>
                        </FlexContainer>
                    </div>
                </FlexContainer>
                <Spinner isOpen={isShowSpinner} />
                {errorMessage && <PaymentError header={errorMessage} message={null} />}
            </>
        } />
    )
};

export default RtpPaymentLink;
